'use client';

import { useFlag, useFlagsStatus } from '@unleash/nextjs';
import { useState } from 'react';
import { AppOnlyGuideModal } from '../AppOnlyGuideModal';
import { WEB_AUTO_VIEWING_FLAG } from './const';

/**
 * `guard()` 를 호출하면 플래그가 해석되어 OFF 일 때 앱 전용 안내 모달을 열고 true(차단)를 돌려준다.
 * `modal` 은 호출부 JSX 에 렌더해야 한다.
 */
export const useAutoViewingBlockGuard = () => {
  const enabled = useFlag(WEB_AUTO_VIEWING_FLAG);
  const { flagsReady, flagsError } = useFlagsStatus();
  const [open, setOpen] = useState(false);

  const guard = () => {
    // 해석 전(useFlag 초기 false)·flagsError 는 허용 (fail-open)
    if (!flagsReady || flagsError || enabled) return false;

    setOpen(true);

    return true;
  };

  const modal = (
    <AppOnlyGuideModal
      isOpen={open}
      onClose={() => setOpen(false)}
      predicate='이용할 수 있어요!'
      subject='오토뷰업은'
    />
  );

  return { guard, modal };
};
